<template>
  <div class="menu-single">
    <template v-if="isBundle">
      <ProductCombo :item="single" />
    </template>
    <template v-else>
      <Product :item="single" />
    </template>
  </div>
</template>

<script>
import Product from '@/components/page/Product/Product'
import ProductCombo from '@/components/page/Product/ProductCombo'

export default {
  components: { Product, ProductCombo },
  computed: {
    getMetaTitle () {
      if (this.single) {
        return this.single.metaTitle ? this.single.metaTitle : `${this.single.name} — доставка и самовывоз в Санкт-Петербурге | СУШИСЕТ`
      }
      return ''
    },
    getMetaDescription () {
      if (this.single) {
        return this.single.metaDescription
          ? this.single.metaDescription
          : `${this.single.name} с доставкой из ресторанов СУШИСЕТ. Бесплатная доставка от 500 рублей и 45 минут! Самовывоз.`
      }
      return ''
    },
    isBundle () {
      return this.single ? this.single.type === 'bundle' : false
    },
  },
  async asyncData ({ $axios, store, route, error }) {
    const slug = route.params.single
    const api = store.getters['api/menuSingle'](slug, 'slug')

    try {
      let single = await $axios.get(api)
      single = single.data.data

      /** Set default meta tags */
      store.commit('seo/setMetaFieldsDefaults', {
        metaTitle: `${single.name} — доставка и самовывоз ${store.getters['region/getCurRegionNamePadeg']} | СУШИСЕТ`,
        metaDescription: `${single.name} с доставкой из ресторанов СУШИСЕТ. Бесплатная доставка от 500 рублей и 45 минут! Самовывоз.`,
        pageTitle: `${single.name}`,
      })

      return {
        single,
      }
    } catch (err) {
      return error({ statusCode: 404, message: 'Продукт не найден' })
    }
  },
}
</script>

<style lang="less">
.menu-single {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  @media (min-width: 992px) {
    margin-top: 20px;
  }
}
</style>
